import { z } from "zod";

export const NOTIFICATION_TYPES = [
  "message.new",
  "application.submitted",
  "application.new",
  "application.daily_digest",
  "application.draft_reminder",
  "job.nearby_recommendations",
  "application.shortlisted",
  "application.interviewing",
  "application.accepted",
  "application.rejected",
  "interview.invite",
  "interview.status_changed",
  "interview.reminder",
  "conversation.ended",
  "user.onboarding_completion_reminder",
] as const;

export const NOTIFICATION_CHANNELS = ["in_app", "email"] as const;

export const NotificationTypeSchema = z.enum(NOTIFICATION_TYPES);
export const NotificationChannelSchema = z.enum(NOTIFICATION_CHANNELS);
export const NotificationStatusSchema = z.enum(["unread", "read", "archived"]);

export const NotificationLinkSchema = z.object({
  href: z.string(),
  label: z.string().optional(),
});

export const NotificationDtoSchema = z.object({
  id: z.string(),
  recipient: z.string(),
  actor: z.string().optional(),
  organization: z.string().optional(),
  type: NotificationTypeSchema,
  status: NotificationStatusSchema,
  priority: z.number().int().min(1).max(10),
  groupId: z.string().optional(),
  metadata: z.record(z.string(), z.unknown()).default({}),
  links: NotificationLinkSchema.optional(),
  readAt: z.coerce.date().optional(),
  archivedAt: z.coerce.date().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const NotificationPreferenceDtoSchema = z.object({
  type: NotificationTypeSchema,
  category: z.string(),
  order: z.number(),
  channels: z.array(NotificationChannelSchema),
  settings: z.array(
    z.object({
      channel: NotificationChannelSchema,
      enabled: z.boolean(),
    })
  ),
});

export type NotificationType = z.infer<typeof NotificationTypeSchema>;
export type NotificationChannel = z.infer<typeof NotificationChannelSchema>;
export type NotificationStatus = z.infer<typeof NotificationStatusSchema>;
export type NotificationDto = z.infer<typeof NotificationDtoSchema>;
export type NotificationPreferenceDto = z.infer<
  typeof NotificationPreferenceDtoSchema
>;
